module.exports = __webpack_public_path__ + "static/media/desconectado.985395bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Integrations/desconectado.svg
// module id = 1803
// module chunks = 0